import React from 'react';

const HolidayTable = ({ holidays, onDeleteHoliday, onUpdateHolidayName, errors = {} }) => {
    const formatDateForDisplay = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    const handleNameChange = (index, value) => {
        onUpdateHolidayName(index, value);
    };

    if (holidays.length === 0) {
        return (
            <div style={{
                padding: '20px',
                textAlign: 'center',
                color: '#6c757d',
                backgroundColor: '#f8f9fa',
                borderRadius: '5px',
                marginTop: '10px'
            }}>
                No holidays added yet. Click "Add" to select holiday dates.
            </div>
        );
    }

    return (
        <div style={{ marginTop: '15px', overflowX: 'auto' }}>
            <table className="table table-bordered" style={{
                width: '100%',
                backgroundColor: '#fff',
                borderRadius: '5px',
                overflow: 'hidden'
            }}>
                <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                        <th style={{ padding: '12px', fontWeight: '600', fontSize: '14px', width: '35%' }}>Date</th>
                        <th style={{ padding: '12px', fontWeight: '600', fontSize: '14px', width: '50%' }}>
                            Holiday Name <span style={{ color: 'red' }}>*</span>
                        </th>
                        <th style={{ padding: '12px', fontWeight: '600', fontSize: '14px', width: '15%', textAlign: 'center' }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {holidays.map((holiday, index) => (
                        <tr key={index}>
                            <td style={{ padding: '12px', fontSize: '14px', verticalAlign: 'middle' }}>
                                {formatDateForDisplay(holiday.date)}
                            </td>
                            <td style={{ padding: '12px', verticalAlign: 'middle' }}>
                                <input
                                    type="text"
                                    className={`form-control ${errors[index] ? 'is-invalid' : ''}`}
                                    placeholder="Enter holiday name (e.g., Christmas, Thanksgiving)"
                                    value={holiday.holiday_name || ''}
                                    onChange={(e) => handleNameChange(index, e.target.value)}
                                    style={{
                                        border: errors[index] ? '1px solid #dc3545' : '1px solid #e1e5e9',
                                        borderRadius: '5px',
                                        padding: '8px 12px',
                                        fontSize: '14px',
                                        width: '100%',
                                        fontWeight: '400'
                                    }}
                                />
                                {errors[index] && (
                                    <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '5px' }}>
                                        {errors[index]}
                                    </div>
                                )}
                            </td>
                            <td style={{ padding: '12px', textAlign: 'center', verticalAlign: 'middle' }}>
                                <button
                                    type="button"
                                    onClick={() => onDeleteHoliday(index)}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        color: '#dc3545',
                                        cursor: 'pointer',
                                        fontSize: '14px',
                                        padding: 0
                                    }}
                                    title="Delete holiday"
                                >
                                    <i className="fa fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default HolidayTable;